import { render, staticRenderFns } from "./StoreTypeTable.vue?vue&type=template&id=122f0890&scoped=true"
import script from "./StoreTypeTable.vue?vue&type=script&lang=js"
export * from "./StoreTypeTable.vue?vue&type=script&lang=js"
import style0 from "./StoreTypeTable.vue?vue&type=style&index=0&id=122f0890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122f0890",
  null
  
)

export default component.exports